<div class="container">
    <h1>Admin</h1>
    @if (!pwdAccepted) {
        <div>
            <label class="w-100" for="pwd">Password</label>
            <p-password [(ngModel)]="pwd" [feedback]="false" autocomplete="off" />
            <p-button class="ms-3" label="Submit" (click)="checkPwd()"></p-button>
        </div>
    }


    @if (statusObject) {
         <p>Source: {{ statusObject.configurationSource }}</p>
         <p>Pim settings available: {{ statusObject.pimSettingsAvailable }}</p>
         <p>TenantId: {{ statusObject.tenantId }}</p>
         <p>Summary: {{ statusObject.summary | json }}</p>
   
    <table class="admin-table">
        <thead>
            <tr>
                <th>Setting</th>
                <th>Configured value</th>
                <th style="width: 100px">Status</th>
                <th style="width: 100px">Type</th>
                <th>Pimkeys</th>
            </tr>
        </thead>
        <tbody>
            
            @for (item of statusObject.items; track item) {
                <tr>
                    <td>{{ item.path }}</td>
                    <td>
                        @if (item.mappingType == 'OBJECT') {
                          {{ getParsed(item.configuredValue) | json }}
                        }
                        @else {
                            {{ item.configuredValue }}
                        }
                    </td>
                    <td style="width: 100px">{{ item.status }}</td>
                    <td style="width: 100px">{{ item.mappingType }}</td>
                    <td>{{ item.pimKeys|json }}</td>
                </tr>
            }

        </tbody>
    </table>
    }
</div>